import { useMutation, useQueryClient } from '@tanstack/react-query'

import { authApi } from '../../auth/api/authApi'
import { COMMUNITIES_CATEGORY } from '../../community/models/community.constants'
import { getCommunitiesCategoryQueryParams, getCommunitiesOptions } from '../../community/services/useCommunitiesQuery'
import type { TWizardPayload } from '../api/types/wizardApi.types'

export const useWizardMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: TWizardPayload) => authApi.patchWizard(payload),
    onSuccess: () => {
      queryClient.invalidateQueries(
        getCommunitiesOptions(getCommunitiesCategoryQueryParams(COMMUNITIES_CATEGORY.SUGGESTED)),
      )
    },
  })
}
